import { Link, NavLink } from 'react-router-dom'
import Logo from '../assets/logo.png'
import trackEvent from './Tracker/MixpanelConfig'
import Avatar from 'react-avatar'
import { useUser } from '../UserContext'
import Notification from './Notification'
import useDropdown from '../hooks/useDropdown'
import { useSidebar } from '../utils/SidebarContext'
import stringShortner from '../utils/stringShortner'
import { navLinks, profileLinks } from '../constants'

export default function Navbar() {
  const { user, setShowAppTour } = useUser()
  const { sideBarRef, isSidebarOpen, toggleSidebar } = useSidebar()

  const {
    isOpen: isProfileDropdownOpen,
    toggleDropdown: toggleProfileDropdown,
    ref: dropdownRef,
  } = useDropdown()

  const {
    isOpen: showMobMenus,
    toggleDropdown: toggleHamBurgereDropdown,
    ref: burgerMenuRef,
  } = useDropdown()

  const displayName = user.displayName
  const userPicture = user.picture
  const userType = user.userType

  return (
    <div className='header'>
      <header className='header-container'>
        <div style={{ display: 'flex', gap: 20 }}>
          {user.token && window.location.pathname !== '/' && (
            <div className='sidebarMenuBtn' ref={sideBarRef}>
              <i
                className={`${isSidebarOpen ? 'bi bi-x' : 'bi bi-list'}`}
                onClick={toggleSidebar}
              ></i>
            </div>
          )}

          <Link to='/'>
            <img className='logo' src={Logo} alt='logo' />
          </Link>
        </div>

        <div className='NavMenus'>
          <div
            ref={burgerMenuRef}
            className={`burgerMenu ${showMobMenus && 'active'}`}
          >
            {navLinks.map(({ to, label }) => (
              <Link key={to} to={to} style={{ marginRight: '15px' }}>
                {label}
              </Link>
            ))}
          </div>

          {/* notification dropdown */}
          {user.token && <Notification />}

          {/* help btn */}
          <Link
            to='#'
            style={{ marginRight: '15px' }}
            onClick={() => setShowAppTour(true)}
          >
            <i className='bi bi-book-fill'></i>
          </Link>

          <div className='NavProfileButton' ref={dropdownRef}>
            {user.token ? (
              <div className='loggedinDropdown'>
                <div
                  className='avatarContainer'
                  onClick={toggleProfileDropdown}
                >
                  {userPicture ? (
                    <div
                      className='dpImg'
                      style={{ backgroundImage: `url(${userPicture})` }}
                    ></div>
                  ) : (
                    <Avatar
                      name={displayName}
                      size='40'
                      className='userdp'
                      textSizeRatio={2}
                    />
                  )}
                  {userType === 'admin' && (
                    <p className='navbar-admin-tag'>Admin</p>
                  )}
                </div>

                {isProfileDropdownOpen && (
                  <div className='dropdown'>
                    {user.userType !== 'admin' ? (
                      <li className='profileTitle'>
                        <p
                          className='oneLineText3dot'
                          style={{ marginInline: 'auto' }}
                        >
                          <b> {stringShortner(displayName, 15)} </b>
                        </p>
                      </li>
                    ) : (
                      <Link to='/admin'>
                        <li className='list'>
                          <i className='bi bi-grid-1x2'></i>
                          Admin Dashboard
                        </li>
                      </Link>
                    )}

                    {profileLinks.map(({ to, icon, label, navLink }) =>
                      navLink ? (
                        <NavLink key={to} to={to}>
                          <li className='list'>
                            <i className={icon}></i> {label}
                          </li>
                        </NavLink>
                      ) : (
                        <Link key={to} to={to}>
                          <li className='list'>
                            <i className={icon}></i> {label}
                          </li>
                        </Link>
                      )
                    )}
                  </div>
                )}
              </div>
            ) : (
              <Link to='/sign-in'>
                <button
                  className='btn shine md-none '
                  onClick={() => {
                    trackEvent('JoinFC on Navbar Clicked')
                  }}
                >
                  Join The FC!
                </button>
              </Link>
            )}
          </div>

          {/* humburgure icon only show for non logged in user */}
          {!user.token && (
            <i
              className='burgerIcon bi bi-list'
              onClick={toggleHamBurgereDropdown}
            ></i>
          )}
        </div>
      </header>
    </div>
  )
}
